import { InjectionToken } from '@angular/core';
import { HxNotificationDataOptions } from '@hubbix/common-components/lib/hx-notifications/models/hx-notification-options';

export const NOTIFICATION_DATA_OPTIONS: InjectionToken<HxNotificationDataOptions> =
  new InjectionToken<HxNotificationDataOptions>('EbpNotificationDataOptions');
